// @flow

import React, { Component } from 'react';
import styler from 'react-styling';

import { CreateMeetingroomEventModal } from '../index';

const style = styler `
  Container
    width: 100%
    height: 100%
    border-radius: 50%
    background-color: #B5F7B5
    cursor: pointer
  PlusContainer
    position: relative
    top: 51%
    transform: translateY(-50%)
  Book
    font-size: 3vw
    color: #0A152D
    margin-top: 2vw
  PlusIcon
    width: 30%
    fill: #0A152D
`;

class MeetingroomAvailableStatus extends Component {

  state = {
    showNewEventModal: this.props.show,
  };

  props: {
    meetingroom: Object,
    nextEvent: Object,
    clock: Object,
    lang: Object,
    show: boolean,
    viewer: Object,
    onBook: Function,
  };

  _handleEventModalOpen = () => {
    this.setState({
      showNewEventModal: true,
    });
  }

  _handleEventModalClose = () => {
    this.setState({
      showNewEventModal: false,
    });
  }

  render() {
    const { lang, meetingroom, viewer, clock, nextEvent, onBook } = this.props;
    const { showNewEventModal } = this.state;
    return (
      <div style={style.Container} onClick={this._handleEventModalOpen}>
        <div style={style.PlusContainer}>
          <svg style={style.PlusIcon} data-name="Add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 454 454">
            <path
              className="st0" d="M446,209H245V8c0-4.4-3.6-8-8-8h-21c-4.4,0-8,3.6-8,8v201H8c-4.4,0-8,3.6-8,8v21c0,4.4,3.6,8,8,8h200v200c0,4.4,3.6,8,8,8h21c4.4,0,8-3.6,8-8V246h201c4.4,0,8-3.6,8-8v-21C454,212.6,450.4,209,446,209z"
            />
          </svg>
          <div style={style.Book}>{lang.book_now}</div>

          <CreateMeetingroomEventModal
            viewer={viewer}
            nextEvent={nextEvent}
            show={showNewEventModal}
            clock={clock}
            lang={lang}
            meetingroom={meetingroom}
            onBook={onBook}
            onClose={this._handleEventModalClose}
          />
        </div>
      </div>
    );
  }

}

export default MeetingroomAvailableStatus;



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingroomAvailableStatus.js